import { z } from 'zod';
import { AbstractGetQuoteResponseSchema } from '../quote/get-quote.ts';
import { CustomisedQuotePayloadByProductTypeSchema } from '../quote/quote-payload.ts';

export const GetQuoteUrlSchema = z.object({
    id: z.string().uuid(),
});

export const GetQuoteResponseSchema = AbstractGetQuoteResponseSchema.and(CustomisedQuotePayloadByProductTypeSchema);

export type GetQuoteResponse = z.infer<typeof GetQuoteResponseSchema>;
